<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCpmaterialpeligroso" role="form" method="post" autocomplete="off" onSubmit="return false">	
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Descripcion">Descripción</label>
							<textarea v-model="objCpMaterialPeligroso.Descripcion" class="form-control" id="Descripcion" placeholder="Ingresar Descripción" rows="3"></textarea>
							<CValidation v-if="this.errorvalidacion.Descripcion" :Mensaje="'*'+errorvalidacion.Descripcion[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Clave">Clave</label>
							<input type="text" v-model="objCpMaterialPeligroso.Clave" class="form-control" id="Clave" placeholder="Ingresar Clave" />
							<CValidation v-if="this.errorvalidacion.Clave" :Mensaje="'*'+errorvalidacion.Clave[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="ClaseDiv">Clase Div</label>
							<input type="text" v-model="objCpMaterialPeligroso.ClaseDiv" class="form-control" id="ClaseDiv" placeholder="Ingresar Clase Div" />
							<CValidation v-if="this.errorvalidacion.ClaseDiv" :Mensaje="'*'+errorvalidacion.ClaseDiv[0]"/>
						</div>
						
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="PeligroSecundario">Peligro Secundario</label>
							<input type="text" v-model="objCpMaterialPeligroso.PeligroSecundario" class="form-control" id="PeligroSecundario" placeholder="Ingresar Peligro Secundario" />
							<CValidation v-if="this.errorvalidacion.PeligroSecundario" :Mensaje="'*'+errorvalidacion.PeligroSecundario[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="GrupoEmbalaje">Grupo Embalaje</label>
							<input type="text" v-model="objCpMaterialPeligroso.GrupoEmbalaje" class="form-control" id="GrupoEmbalaje" placeholder="Ingresar Grupo Embalaje" />
							<CValidation v-if="this.errorvalidacion.GrupoEmbalaje" :Mensaje="'*'+errorvalidacion.GrupoEmbalaje[0]"/>
						</div>
						
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="DispEspec">Disp Espec</label>
							<input type="text" v-model="objCpMaterialPeligroso.DispEspec" class="form-control" id="DispEspec" placeholder="Ingresar Disp Espec" />
							<CValidation v-if="this.errorvalidacion.DispEspec" :Mensaje="'*'+errorvalidacion.DispEspec[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="CantLimitExceptuadas1">Cantidad Limite Exceptuadas 1</label>
							<input type="text" v-model="objCpMaterialPeligroso.CantLimitExceptuadas1" class="form-control" id="CantLimitExceptuadas1" placeholder="Ingresar Cantidad Limite Exceptuadas 1" />
							<CValidation v-if="this.errorvalidacion.CantLimitExceptuadas1" :Mensaje="'*'+errorvalidacion.CantLimitExceptuadas1[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="CantLimitExceptuadas2">Cantidad Limite Exceptuadas 2</label>
							<input type="text" v-model="objCpMaterialPeligroso.CantLimitExceptuadas2" class="form-control" id="CantLimitExceptuadas2" placeholder="Ingresar Cantidad Limite Exceptuadas 2" />
							<CValidation v-if="this.errorvalidacion.CantLimitExceptuadas2" :Mensaje="'*'+errorvalidacion.CantLimitExceptuadas2[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="EmbalEnvases1">Embalaje Envases 1</label>
							<input type="text" v-model="objCpMaterialPeligroso.EmbalEnvases1" class="form-control" id="EmbalEnvases1" placeholder="Ingresar Embalaje Envases 1" />
							<CValidation v-if="this.errorvalidacion.EmbalEnvases1" :Mensaje="'*'+errorvalidacion.EmbalEnvases1[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="EmbalEnvases2">Embalaje Envases 2</label>
							<input type="text" v-model="objCpMaterialPeligroso.EmbalEnvases2" class="form-control" id="EmbalEnvases2" placeholder="Ingresar Embalaje Envases 2" />
							<CValidation v-if="this.errorvalidacion.EmbalEnvases2" :Mensaje="'*'+errorvalidacion.EmbalEnvases2[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="CisternasPortatiles1">Cisternas Portatiles 1</label>
							<input type="text" v-model="objCpMaterialPeligroso.CisternasPortatiles1" class="form-control" id="CisternasPortatiles1" placeholder="Ingresar Cisternas Portatiles 1" />
							<CValidation v-if="this.errorvalidacion.CisternasPortatiles1" :Mensaje="'*'+errorvalidacion.CisternasPortatiles1[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="CisternasPortatiles2">Cisternas Portatiles 2</label>
							<input type="text" v-model="objCpMaterialPeligroso.CisternasPortatiles2" class="form-control" id="CisternasPortatiles2" placeholder="Ingresar Cisternas Portatiles 2" />
							<CValidation v-if="this.errorvalidacion.CisternasPortatiles2" :Mensaje="'*'+errorvalidacion.CisternasPortatiles2[0]"/>
						</div>
					</div>

					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCpMaterialPeligroso',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCpMaterialPeligroso: {
				IdMaterial: 0,
				Descripcion: '',
				Clave: '',
				ClaseDiv: '',
				PeligroSecundario: '',
				GrupoEmbalaje: '',
				DispEspec: '',
				CantLimitExceptuadas1: '',
				CantLimitExceptuadas2: '',
				EmbalEnvases1: '',
				EmbalEnvases2: '',
				CisternasPortatiles1: '',
				CisternasPortatiles2: '',
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCpMaterialPeligroso.IdMaterial == 0) {
				await this.$http.post(
					'cpMaterialesPeligrosos',this.objCpMaterialPeligroso
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'cpMaterialesPeligrosos/'+this.objCpMaterialPeligroso.IdMaterial,
					this.objCpMaterialPeligroso
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "cpMaterialesPeligrosos/"+this.objCpMaterialPeligroso.IdMaterial
            ).then((res) => {
                this.objCpMaterialPeligroso = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCpMaterialPeligroso.Fecha.replace(/-/g,'\/');
                this.objCpMaterialPeligroso.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCpMaterialPeligroso = {
				IdMaterial: 0,
				Descripcion: '',
				Clave: '',
				ClaseDiv: '',
				PeligroSecundario: '',
				GrupoEmbalaje: '',
				DispEspec: '',
				CantLimitExceptuadas1: '',
				CantLimitExceptuadas2: '',
				EmbalEnvases1: '',
				EmbalEnvases2: '',
				CisternasPortatiles1: '',
				CisternasPortatiles2: '',
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCpMaterialPeligroso.IdMaterial = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
